<template>
    <view-card headline="날짜정보" :disabled="disabled">
        <v-row>
            <v-col class="py-0"><v-date-field v-model="value.startsAt" label="공사시작일" placeholder=" " hideDetails/></v-col>
            <v-col class="py-0"><v-date-field v-model="value.endsAt" label="공사종료일" placeholder=" " hideDetails/></v-col>
            <v-col class="py-0"><v-date-field v-model="value.signsAt" label="계약일" placeholder=" " hideDetails/></v-col>
        </v-row>
    </view-card>
</template>
<script>
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import viewCard from "../dumb/view-card.vue";
export default {
    components: { viewCard, VDateField },
    props: {
        value: {
            startsAt: { type: Date, default: null },
            endsAt: { type: Date, default: null },
            signsAt: { type: Date, default: null },
        },
        disabled: { type: Boolean, default: true },
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.$emit("input", { ...this.value, startsAt: this.value.startsAt?.toDate() || null, endsAt: this.value.endsAt?.toDate() || null, signsAt: this.value.signsAt?.toDate() || null });
        },
    },
};
</script>
